module.exports = __webpack_public_path__ + "img/back_rise.4bf31ed7.png";